export const hoverStyle = {
    color: '#208f84',
    transform: 'scale(1.025) translateY(-5px)',
}
export const hoverStyleTransformOnly = {
    transform: 'scale(1.025) translateY(-5px)',
}

export const iconColor = "#aecbcd"
export const buttonColor = "#078376"
export const buttonColorHover = "#045b52"
export const successTextColor = "#078376"
export const warningTextColor = '#febf58'
export const errorTextColor = "#f95959"
